export const getApiUrl = () => {
    return typeof document !== 'undefined'
        ? `${window.location.protocol}//${window.location.host}`
        : process.env.API_HOST || 'http://localhost:3000';
};
